import React, { useReducer, createContext, useContext, useState } from "react";
import { ApiContext } from "./ApiKey";

const initialState = {
  user: null,
};

const AuthContext = createContext({
  user: null,
  login: (userData) => {},
  logout: () => {},
});

function authReducer(state, action) {
  switch (action.type) {
    case "LOGIN": {
      return {
        ...state,
        user: action.payload,
      };
    }
    case "LOGOUT": {
      return {
        ...state,
        user: null,
      };
    }
    default:
      return state;
  }
}

function AuthProvider(props) {
  const [state, dispatch] = useReducer(authReducer, initialState);
  const [lockModal, setLockModal] = useState(false);
  const { SetApikey } = useContext(ApiContext);
  const login = (userData) => {
    // localStorage.setItem("user", JSON.stringify(userData));
    dispatch({
      type: "LOGIN",
      payload: userData,
    });
  };
  const logout = () => {
    SetApikey(null);
    dispatch({
      type: "LOGOUT",
    });
  };

  return (
    <AuthContext.Provider
      value={{ user: state.user, login, logout, lockModal, setLockModal }}
      {...props}
    />
  );
}

export { AuthContext, AuthProvider };
